declare global {
  interface Window {
    dataLayer: any;
  }
}

interface GA4Events {
  alf_page_view: pageViewParams;
  component_click: componentClickParams;
}

type pageViewParams = defaultParams & {
  user_code_provider_hit: string;
  referer?: string;
};

type componentClickParams = defaultParams & {
  component_name: string;
  component_type: string;
  component_item_link_redirect: string;
};

type defaultParams = {
  page_name_custom?: string;
  provider_name: string;
};

type userParams = {
  user_code: string;
  user_code_provider: string;
  user_code_hit?: string;
};

export const sendEvent = (
  eventName: keyof GA4Events,
  eventParams: GA4Events[typeof eventName],
  userParams: userParams
) => {
  const globoId = localStorage.getItem("globoId");
  if (globoId) {
    userParams.user_code_hit = globoId;
  }

  window.dataLayer.push({
    event: "custom_event",
    event_name: eventName,
    ...eventParams,
    ...userParams
  });
};
